import "./FormField.scss";
import { Form } from 'react-bootstrap';

const FormInputText = (props) => {
  const { label, placeholder, value, name, setFunc, showLabel, disabled, keyName, type = 'input', rows = 1 } = props;

  return (
    <Form.Group controlId={label}>
      {showLabel && (<Form.Label>{label}</Form.Label>)}
      {
        rows > 1 ? 
        (
          <Form.Control
            as="textarea"
            type={type}
            name={name}
            placeholder={placeholder}
            rows={rows}
            value={value}
            onChange={(event) => setFunc(event.target.value, event.target.name, keyName)}
            disabled={disabled}
          />
        ) 
          : 
        (
          <Form.Control
            type={type}
            name={name}
            placeholder={placeholder}
            rows={rows}
            value={value}
            onChange={(event) => setFunc(event.target.value, event.target.name, keyName)}
            disabled={disabled}
          />
        )
      }
      
    </Form.Group>
  );
};

export default FormInputText;